import { download, map, slideshow, social_sharing, social_sharing_platforms } from "../settings";
import useMeowLightboxContext from "../context";
import { useController } from "../helpers";
import { MwlIcons } from "../components/MwlIcons";

import i18n from "../../admin/i18n";

export const Actions = () => {

  console.log('🎞️ Rendering Meow Lightbox Actions');

  const { image, currentUrl, isPlaying, isExtended, isMapOpen} = useMeowLightboxContext();
  const { onCloseClick, onDownloadClick, onPlayClick, onPauseClick, onMapClick,
    onFullscreenClick, onShrinkClick } = useController();

  const items = [
    {
      visible: Boolean(social_sharing),
      icon: 'sharing',
      className: 'mwl__topbar__controls__control--sharing',
      children : currentUrl && (
        <div className="mwl__topbar__controls__control--sharing__options">
          {social_sharing_platforms.map(({ label, path, enabled }) => (
            enabled && <li><a href={`${path}${currentUrl}`} target="_blank">{`${i18n.TOOLBAR.SHARE_ON} ${label}`}</a></li>
          ))}
        </div>
      )
    },
    {
      visible: download.enabled && image.download_link,
      label: i18n.TOOLBAR.DOWNLOAD,
      icon: 'download',
      onClick: onDownloadClick,
      className: 'mwl__topbar__controls__control--download'
    },
    {
      visible: slideshow.enabled,
      label: i18n.TOOLBAR.PLAY,
      icon: 'play',
      onClick: onPlayClick,
      className: `mwl__topbar__controls__control--play ${isPlaying ? "hidden" : ""}`
    },
    {
      visible: slideshow.enabled,
      label: i18n.TOOLBAR.PAUSE,
      icon: 'pause',
      onClick: onPauseClick,
      className: `mwl__topbar__controls__control--pause ${!isPlaying ? "hidden" : ""}`
    },
    {
      visible: map.enabled && image.gps && image.gps.lat !== "N/A" && image.gps.lng !== "N/A",
      label: isMapOpen ? i18n.TOOLBAR.MAP_IMAGE : i18n.TOOLBAR.MAP_SHOW,
      icon: isMapOpen ? 'image' : 'map',
      onClick: onMapClick,
      className: 'mwl__topbar__controls__control--map'
    },
    {
      visible: true,
      label: i18n.TOOLBAR.FULLSCREEN,
      icon: 'fullscreen',
      onClick: onFullscreenClick,
      className: `mwl__topbar__controls__control--fullscreen ${isExtended ? "hidden" : ""}`
    },{
      visible: true,
      label: i18n.TOOLBAR.SHRINK,
      icon: 'shrink',
      onClick: onShrinkClick,
      className: `mwl__topbar__controls__control--shrink ${!isExtended ? "hidden" : ""}`
    },
    {
      visible: true,
      label: i18n.TOOLBAR.CLOSE,
      icon: 'close',
      onClick: onCloseClick,
      className: 'mwl__topbar__controls__control--close',
    }
  ];

  return items.filter(v => v.visible)
    .map(({ children, label, icon, onClick, className }) =>
      <div className={`mwl__topbar__controls__control ${className}`}
        onClick={(e) => {
          e.stopPropagation();
          if (onClick) {
            onClick();
          }
        }}
      >
        <MwlIcons icon={icon} />
        {!!label && <div className="mwl__topbar__controls__control__label">{label}</div>}
        {children}
      </div>
    );
};
